import Styles from './dumb-tile.style';

export const DumbTile: React.FC<{
  label: string;
  title: string;
  isBlurred?: boolean;
  progressBar?: {
    progress: number;
    showLabel?: boolean;
    progressBarColor?: string;
  };
}> = ({ label, title, progressBar, isBlurred }) => {
  return (
    <>
      <Styles.Item href={isBlurred ? '/start/signup' : undefined}>
        <Styles.ItemContent>
          <Styles.ItemLabel size="small">{label}</Styles.ItemLabel>
          {progressBar && (
            <Styles.TilesProgressBar
              progress={progressBar.progress}
              showLabel={progressBar.showLabel}
              progressBarColor={progressBar.progressBarColor}
            />
          )}
          <Styles.Title size="medium" $isBlurred={isBlurred}>
            {title}
          </Styles.Title>
        </Styles.ItemContent>
      </Styles.Item>
    </>
  );
};
